import { Injectable } from '@angular/core';
import { FenixDossierBaseService } from './base/fenix-dossier-base.service';

@Injectable({
    providedIn: 'root',
})
export class FenixDossierService extends FenixDossierBaseService {
    constructor() {
        super();
    }
}
